import { createSelector } from 'reselect';
import { contributorsSelector } from './contributors';
import { syncTeamsTreeSelector } from './teams';
import { getTreeTeamsContributors } from 'common/utils/contributors.utils';

export const teamsTreeSelectorWithContribCountSelector = createSelector(
  [contributorsSelector, syncTeamsTreeSelector],
  (contributors, teams) => {
    const attachTotalContributors = team => {
      return {
        ...team,
        totalContributors: getTreeTeamsContributors({
          teams: [team],
          contributors
        }),
        children: team.children?.map(attachTotalContributors) || []
      };
    };

    return teams.map(attachTotalContributors);
  }
);
